import React from "react";

interface SideBarCheckProps {
  selected: boolean;
}

export const SideBarCheck: React.FC<SideBarCheckProps> = ({ selected }) => {
  return (
    <div
      className="w-[32px] h-[32px] flex items-center justify-center rounded-full"
      style={{
        backgroundColor: selected ? "#5A6ED5" : "#EAEBF0", // Blue when selected, gray otherwise
      }}
    >
      {selected && <span className="checkmark text-white">✓</span>}
    </div>
  );
};
